import Vue from "vue";
import Vuex from "vuex";
import * as session from "./modules/sessionModule";
import * as app from "./modules/appModule";
import * as booking from "./modules/bookingModule";

Vue.use(Vuex);

export interface RootState {
  session: session.SessionState;
  app: app.AppState;
  booking: booking.BookingState;
}
export default new Vuex.Store({
  modules: {
    session,
    app,
    booking
  },
  strict: process.env.APP_ENV !== "production"
});
